import React, { useState } from 'react';
import { Container, Paper, Typography, Button, TextField } from '@mui/material';
import { useApiBaseUrl } from '../context/ApiContext';

const Reports = ({ selectedCustomerId }) => {
  const ApiBaseUrl = useApiBaseUrl();
  const [startDate, setStartDate] = useState('2024-10-01');
  const [endDate, setEndDate] = useState('2024-10-31');

  const fetchDistributorOrderReport = () => {
    if (!startDate || !endDate) {
      alert('Please enter both start and end dates');
      return;
    }

    const encodedStartDate = encodeURIComponent(startDate);
    const encodedEndDate = encodeURIComponent(endDate);
    const url = `${ApiBaseUrl}/api/Sales/GetDistributorOrderReport?startDate=${encodedStartDate}&endDate=${encodedEndDate}&distributorId=${selectedCustomerId}`;

    downloadReport(url, 'DistributorOrderReport.xlsx');
  };

  const fetchPreOrdersReport = () => {
    const url = `${ApiBaseUrl}/api/Sales/${selectedCustomerId}/Get_SeasonalAllocationReport_ByCustomerId`;
    downloadReport(url, 'PreOrdersReport.xlsx');
  };

  const downloadReport = (url, filename) => {
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
        alert('Failed to fetch the report. Please try again.');
      });
  };

  return (
    <>
      <Container component={Paper} style={{ padding: '20px', marginTop: '20px' }}>
        <Typography variant="h5" gutterBottom>Distributor Order Report</Typography>
        <TextField
          label="Start Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          margin="normal"
        />
        <TextField
          label="End Date"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          margin="normal"
        />
        <Button 
          variant="contained" 
          color="primary" 
          onClick={fetchDistributorOrderReport}
          style={{ marginTop: '20px', marginRight: '10px' }}
        >
          Download Distributor Order Report
        </Button>
      </Container>
      <Container component={Paper} style={{ padding: '20px', marginTop: '20px' }}>
        <Typography variant="h5" gutterBottom>Pre-Orders Report</Typography>
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={fetchPreOrdersReport}
          style={{ marginTop: '20px' }}
        >
          Download Pre-Orders Report
        </Button>
      </Container>
    </>
  );
};

export default Reports;